import { useEffect, useState } from "react";
import Input from "../../../../../utils/components/Input";
import SelectBox from "../../../../../utils/components/SelectBox";
import Button from "../../../../../utils/components/Button";
import { IoIosSnow } from "react-icons/io";
import { MdOutlineDeleteOutline } from "react-icons/md";

const StepResults = ({
  step,
  stepsList,
  handleAction,
  translate,
  workflowType,
}) => {
  const [stepResults, setStepResults] = useState(step.settings.results || []);
  const resultsType =
    stepsList?.findIndex((singleStep) => singleStep?.id === step?.step_code) ===
      0 && workflowType === "auto"
      ? [{ value: "accept", label: translate("accept") }]
      : [
          { value: "accept", label: translate("accept") },
          { value: "reject", label: translate("reject") },
        ];

  const addResult = () => {
    setStepResults([
      ...stepResults,
      {
        result_code: "",
        result_type: "",
        result_step: "",
      },
    ]);
  };

  const removeResult = (index) => {
    const newStepResults = [...stepResults];
    newStepResults.splice(index, 1);
    setStepResults(newStepResults);
  };

  const handleSelectChange = (value, index, type) => {
    const newStepResults = [...stepResults];
    newStepResults[index][type] = value;
    setStepResults(newStepResults);
  };

  useEffect(() => {
    handleAction("step_results", stepResults);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepResults]);

  return (
    <div>
      {stepResults?.map((item, index) => (
        <div className="row mt-4" key={index}>
          <div className="col-3">
            <p className="text-gray text-uppercase fw-bold mb-2">
              {translate("design_approval_process.step-edit-modal.result-code")}
            </p>
            <Input
              type="text"
              value={item.result_code}
              onChange={(e) =>
                handleSelectChange(e.target.value, index, "result_code")
              }
            />
          </div>
          <div className="col-3">
            <p className="text-gray text-uppercase fw-bold mb-2">
              {translate("design_approval_process.step-edit-modal.result")}
            </p>
            <SelectBox
              options={resultsType}
              onChange={(data) => {
                handleSelectChange(data.value, index, "result_type");
              }}
              value={
                resultsType.find(
                  (rt) => rt.value === stepResults[index].result_type
                ) || ""
              }
              placeholder={translate(
                "design_approval_process.step-edit-modal.placeholders.select-result"
              )}
            />
          </div>
          <div className="col-4">
            <p className="text-gray text-uppercase fw-bold mb-2">
              {translate("design_approval_process.step-edit-modal.result-step")}
            </p>
            <SelectBox
              options={stepsList}
              onChange={(data) =>
                handleSelectChange(data.value, index, "result_step")
              }
              value={stepsList.find((step) => step.value === item.result_step)}
              placeholder={translate(
                "design_approval_process.step-edit-modal.placeholders.select-result-step"
              )}
            />
          </div>
          <div className="col-2">
            <Button
              className="btn btn-danger mb-0 mt-4"
              onClick={() => removeResult(index)}
            >
              <MdOutlineDeleteOutline className="my-1" />
            </Button>
          </div>
        </div>
      ))}
      <div className="row mt-3 pb-5">
        <div className="col-12">
          <Button
            className="btn-orange text-white text-uppercase fw-bold ps-2 pe-3 my-1"
            onClick={addResult}
          >
            <IoIosSnow className="fs-5 me-2 mb-1" />
            <span>
              {translate("design_approval_process.step-edit-modal.add-result")}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};
export default StepResults;
